// src/lib/escalation.ts
const ESCALATION_SIGNALS = [
  'criminal charge', 'felony', 'misdemeanor', 'arrested', 'indicted', 'charged with',
  'warrant', 'probation', 'parole', 'prison', 'jail time',
  'divorce', 'child custody', 'custody battle', 'visitation rights', 'alimony', 'child support',
  'immigration', 'deportation', 'visa denial', 'asylum', 'undocumented', 'green card',
  'restraining order', 'domestic violence', 'protective order',
  'personal injury', 'medical malpractice', 'wrongful death',
  'bankruptcy', 'foreclosure', 'tax fraud', 'irs audit',
  'sexual harassment', 'discrimination lawsuit', 'wrongful termination',
  'class action', 'federal court', 'appeals court',
  '[LAWYER_RECOMMENDED]',
];

type EscalationCategory =
  | 'criminal' | 'family' | 'immigration' | 'safety'
  | 'injury' | 'financial' | 'employment' | 'litigation' | 'estate';

const CATEGORY_MAP: Record<string, EscalationCategory> = {
  'criminal charge': 'criminal', felony: 'criminal', misdemeanor: 'criminal',
  arrested: 'criminal', indicted: 'criminal', 'charged with': 'criminal',
  warrant: 'criminal', probation: 'criminal', parole: 'criminal',
  prison: 'criminal', 'jail time': 'criminal',
  divorce: 'family', 'child custody': 'family', 'custody battle': 'family',
  'visitation rights': 'family', alimony: 'family', 'child support': 'family',
  immigration: 'immigration', deportation: 'immigration', 'visa denial': 'immigration',
  asylum: 'immigration', undocumented: 'immigration', 'green card': 'immigration',
  'restraining order': 'safety', 'domestic violence': 'safety', 'protective order': 'safety',
  'personal injury': 'injury', 'medical malpractice': 'injury', 'wrongful death': 'injury',
  bankruptcy: 'financial', foreclosure: 'financial', 'tax fraud': 'financial', 'irs audit': 'financial',
  'sexual harassment': 'employment', 'discrimination lawsuit': 'employment', 'wrongful termination': 'employment',
  'class action': 'litigation', 'federal court': 'litigation', 'appeals court': 'litigation',
  '[LAWYER_RECOMMENDED]': 'criminal',
};

export interface EscalationResult {
  shouldNudge: boolean;
  category: EscalationCategory | null;
  cleanedText: string;
}

export function checkForEscalation(text: string): EscalationResult {
  // Strip the [LAWYER_RECOMMENDED] marker from displayed text
  const cleanedText = text.replace(/\[LAWYER_RECOMMENDED\]/g, '').trim();
  const hasMarker = text.includes('[LAWYER_RECOMMENDED]');

  const lower = text.toLowerCase();
  const found = ESCALATION_SIGNALS.filter(s => lower.includes(s.toLowerCase()));
  const category = hasMarker
    ? (found.find(s => s !== '[LAWYER_RECOMMENDED]') ? CATEGORY_MAP[found.find(s => s !== '[LAWYER_RECOMMENDED]')!] : null)
    : (found.length > 0 ? (CATEGORY_MAP[found[0]] ?? null) : null);

  return {
    shouldNudge: hasMarker || found.length > 0,
    category,
    cleanedText,
  };
}
